import { gql } from '@apollo/client';

export const LEAD_CREATE = gql`
  mutation LibraryNewsletterLeadCreate($email: String!, $tag: String!) {
    leadCreate(email: $email, tag: $tag) {
      email
    }
  }
`;
